// TODO: rename to meta.ts to sns.ts
export const THIS_GITHUB_URL = "https://github.com/snamiki1212/plangoab";
export const MY_GITHUB_URL = "https://github.com/snamiki1212";
export const MY_TWITTER_URL = "https://twitter.com/snamiki1212";
export const MY_PORTFOLIO = "https://snamiki1212.github.io";
